function tasks(state = { tasks : [],myTasks:[] , referStaffs: [] ,referResult : false  }, action) {
  
    switch (action.type) {
      
      case "GET_TASKS":
        return {
          ...state,
          tasks: action.data
        };
        case "GET_MY_TASKS":
          return {
            ...state,
            myTasks: action.data
          };
          case "GET_STAFF":
        return {
          ...state,
          referStaffs: action.data
        };
            case "SAVE_REFER":
        return {
          ...state,
          referResult: action.data
        };
          
      default:
        return state;
    }
  }
  
  export default tasks;